import React from 'react';
import { useProduct } from '@montana/containers/product';
import { Translate } from '@montana/shared/translate';
import { Link } from '@montana/shared/link';
import { useSettings } from '@montana/containers/settings/settings.container';
import { CUSTOMER_MODE } from "@montana/constants/customer-mode";

export const Series = () => {

    const { series, designer, properties } = useProduct();
    const { customerMode } = useSettings();

    const designerLink = customerMode === CUSTOMER_MODE.PROFESSIONAL ? designer?.professionalDesignerPageLink : designer?.privateDesignerPageLink;
    const seriesLink = customerMode === CUSTOMER_MODE.PROFESSIONAL ? series?.professionalSeriesPageLink : series?.privateSeriesPageLink;

    return properties?.seriesTeaserText || properties?.seriesDescription || series?.seriesTeaserText || series?.seriesDescription ? (
        <section className="series-section">
            <div className="series-section__column series-section__teaser-text" dangerouslySetInnerHTML={{__html: properties?.seriesTeaserText ?? series?.seriesTeaserText ?? ''}}></div>
            <div className="series-section__column">
                <div className="series-section__description" dangerouslySetInnerHTML={{__html: properties?.seriesDescription ?? series?.seriesDescription ?? ''}}></div>

                {!!designer?.designerName && (
                    <div className="series-section__group">
                        <div className="series-section__group-label"><Translate value="productPage.productPageDesigner" defaultValue="[Designer]" />:</div>
                        <div className="series-section__group-text">
                            {!!designer?.designerName && <Link withStroke={!!designerLink} to={designerLink}>{designer.designerName}</Link>}
                        </div>
                    </div>
                )}
                {!!series?.seriesName && (
                    <div className="series-section__group">
                        <div className="series-section__group-label"><Translate value="productPage.productPageSeries" defaultValue="[Series]" />:</div>
                        <div className="series-section__group-text">
                            {!!series?.seriesName && <Link withStroke={!!seriesLink} to={seriesLink}>{series.seriesName}</Link>}
                        </div>
                    </div>
                )}
                {!!series?.seriesYear && (
                    <div className="series-section__group">
                        <div className="series-section__group-label"><Translate value="productPage.productPageYear" defaultValue="[Year]" />:</div>
                        <div className="series-section__group-text">{series.seriesYear}</div>
                    </div>
                )}
            </div>
        </section>
    ) : null;
};
